import { Directive, HostListener, Host, Optional } from '@angular/core';
import { Calendar } from 'primeng/calendar';

@Directive({
  selector: '[appCalendarEscapeClose]',
})
export class CalendarEscapeCloseDirective {
  constructor(@Host() @Optional() private calendar: Calendar) {}

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    if (this.calendar && this.calendar.overlayVisible) {
      this.calendar.hideOverlay();
      event.preventDefault();
    }
  }
}
